import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'safeCurrency',
  standalone: true
})
export class SafeCurrencyPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  transform(value: string | number, currencyCode: string = 'BRL', display: string = 'symbol', digitsInfo: string = '1.2-2', locale: string = 'pt-BR'): string {
    if (value === 'N/A' || value === null || value === undefined) {
      return 'N/A';
    }

    const numValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;

    if (isNaN(numValue)) {
      return 'N/A';
    }

    return this.currencyPipe.transform(numValue, currencyCode, display, digitsInfo, locale) || 'N/A';
  }
}
